import { Injectable } from '@angular/core';
import { UrlTree, CanLoad, Route, UrlSegment, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class PublicGuard implements CanLoad {
  constructor(private authService: AuthService, private router: Router) { }
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
    return this.authService.isAuthenticated.pipe(
      filter((value) => value !== null),
      take(1),
      map((isAuthenticated) => {
        if (!isAuthenticated) {
          return true;
        } else {
          this.router.navigateByUrl('/transaction');
          return false;
        }
      })
    );
  }
}
